import { useEffect } from 'react';
import { usePermissionAddAccountingEntries } from '@app/modules/mje/api/Api/useUserProfilePermissionApi';

export const useAddAccountingEntriesPermission = () => {
  const { isLoading, userProfilePermission, fetchPermission } =
    usePermissionAddAccountingEntries();

  useEffect(() => {
    fetchPermission();
  }, [fetchPermission]);

  return {
    addAccountingEntries: userProfilePermission?.addAccountingEntries ?? null,
    isLoading,
    fetchPermission,
  };
};
